import React from 'react';

interface AgentNotesViewerProps {
  notes: string | null | undefined;
}

export const AgentNotesViewer: React.FC<AgentNotesViewerProps> = ({ notes }) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        Agent Notes
      </label>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">
        Private notes the AI assistant has written about your preferences and working style.
        These are maintained automatically by the agent and used to personalize its responses.
      </p>
      {notes ? (
        <div className="w-full px-3 py-2 text-sm bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300 whitespace-pre-wrap">
          {notes}
        </div>
      ) : (
        <div className="w-full px-3 py-4 text-sm bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-md text-gray-400 dark:text-gray-500 text-center italic">
          No notes yet. The AI assistant will add notes here as it learns about your preferences.
        </div>
      )}
    </div>
  );
};
